import React from 'react';

import { ModalProvider } from '../context/ModalContext';
import useUser from '../utils/useUser';

import GTM from './GTM';
import Layoutv2 from './Layout/Layoutv2';

const Layout = ({ children, ...otherProps }) => {
    const { user, userLoading, statusLoading } = useUser();
    return (
        <ModalProvider>
            <GTM />
            <Layoutv2
                user={user}
                userLoading={userLoading}
                statusLoading={statusLoading}
                {...otherProps}
            >
                {children}
            </Layoutv2>
        </ModalProvider>
    );
};
export default Layout;
